import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const refundsApiService = createApi({
  reducerPath: 'refundsApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/refund/'),
  endpoints: (builder) => ({
    getRefunds: builder.query({
      query: (args) => {
        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let query = queryParams(args)

        return `get${query}`
      },
      keepUnusedDataFor: 0
    }),
    updateRefund: builder.mutation({
      query: (body) => ({
        url: `update/${body?._id}`,
        method: "PUT",
        body
      })
    })
  })
})

export const {
  useGetRefundsQuery,
  useUpdateRefundMutation
} = refundsApiService